import {
  FETCH_PROMOS,
  FETCH_PROMOS_SUCCESS,
  FETCH_PROMOS_FAILED,
  EDIT_PROMOS
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import { onValue, push, update, remove, runTransaction, child, set } from "firebase/database";
import { PROMO_ADMIN_FIELDS } from '../other/promoFunctions';

export const fetchPromos = () => (dispatch) => {

  const {
    promoRef
  } = firebase;

  dispatch({
    type: FETCH_PROMOS,
    payload: null
  });
  onValue(promoRef, snapshot => {
    if (snapshot.val()) {
      const data = snapshot.val();
      const arr = Object.keys(data).map(i => {
        data[i].id = i;
        return data[i]
      });
      dispatch({
        type: FETCH_PROMOS_SUCCESS,
        payload: arr
      });
    } else {
      dispatch({
        type: FETCH_PROMOS_FAILED,
        payload: "No promos available."
      });
    }
  });
};

const pickAdminFields = (promo) => {
  const out = {};
  PROMO_ADMIN_FIELDS.forEach((k) => {
    if (promo[k] !== undefined) out[k] = promo[k];
  });
  return out;
};

/** Admin. 'Update' solo toca los campos de configuración: no pisa los contadores de uso. */
export const editPromo = (promo, method) => async (dispatch) => {
  const {
    promoRef,
    promoEditRef
  } = firebase;
  dispatch({
    type: EDIT_PROMOS,
    payload: { method, promo }
  });
  if (method === 'Add') {
    await push(promoRef, { ...pickAdminFields(promo), user_avail: 0 });
  } else if (method === 'Delete') {
    await remove(promoEditRef(promo.id));
  } else if (method === 'Update') {
    await update(promoEditRef(promo.id), pickAdminFields(promo));
  }
};

export const setPromoVisibility = (id, show) => async () => {
  const { promoEditRef } = firebase;
  await update(promoEditRef(id), { promo_show: !!show });
};

/**
 * Cliente: reserva un uso del promo. El contador se incrementa en una transacción para que
 * el límite de usos se respete aunque varios clientes lo apliquen a la vez.
 */
export const claimPromoUsage = async (promo, uid) => {
  const { promoEditRef } = firebase;
  const promoNode = promoEditRef(promo.id);
  const limit = parseFloat(promo.promo_usage_limit) || 0;
  const tx = await runTransaction(child(promoNode, 'user_avail'), (cur) => {
    const used = parseFloat(cur) || 0;
    if (limit > 0 && used >= limit) return;
    return used + 1;
  });
  if (!tx.committed) return { ok: false, reason: 'exhausted' };
  await set(child(promoNode, `usersUsed/${uid}`), true);
  return { ok: true };
};

export const releasePromoUsage = async (promoId, uid) => {
  const { promoEditRef } = firebase;
  if (!promoId) return;
  const promoNode = promoEditRef(promoId);
  await runTransaction(child(promoNode, 'user_avail'), (cur) => Math.max(0, (parseFloat(cur) || 0) - 1));
  await remove(child(promoNode, `usersUsed/${uid}`));
};
